const short = require("short-uuid");
const baseModel = require("../baseModel")

/**
 * プロジェクト用のデータ取得モデルクラス
 */
class InspectMasterModel extends baseModel {
  /**
   * テナント内のプロジェクトリストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async getInspectMasterList(projectId) {
    return await super.getList({ beginsWith: `inspectMaster#${projectId}` })
  }

  /**
   * プロジェクトを削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async deleteInspectMaster(data) {
    await super.deleteData(data)
  }

  /**
   * プロジェクト管理レコードを追加する
   * @param {*} data
   */
  static async addInspectMaster(data) {
    await super.addData(data)
  }

  /**
   * プロジェクト管理レコードを更新する
   * @param {*} data
   */
  static async updateInspectMaster(data) {
    await super.updateData(data)
  }

  /**
   * プロジェクト管理レコードを取得する
   * @param {*} data
   */
  static async getInspectMaster(sk) {
    return await super.getSingleData({sk: sk});
  }

  /**
   * skの文字列を生成
   * @param {*}
   * @returns
   */
  static createSk(projectId, id) {
    return `inspectMaster#${projectId}#${id}`;
  }
  /**
   * 新規登録用のスキーマ
   */
  static async getNewData(projectId) {
    let newRowData = await super.getNewData()
    
    const id = short.generate()
    newRowData.sk = this.createSk(projectId, id)
    
    newRowData.inspectMaster = {
      id: id,
      name: "",
      inspectItemList: [],
      iconSetting: [],
      inputMaster: [],
      lockFlg: false
    }

    return newRowData
    
  }
}

module.exports = InspectMasterModel;
